import type { UnitFormatterWithOptions } from "./types";
import { toFixed } from "./value-formats";

export const toPercent: UnitFormatterWithOptions = (size, { precision } = {}) => `${toFixed(size, precision)}%`;

export const toPercentUnit: UnitFormatterWithOptions = (size, { precision } = {}) =>
	`${toFixed(100 * size, precision)}%`;

export const toHex0x: UnitFormatterWithOptions = (value, options?) => {
	const text = toHex(value, options);

	if (text.startsWith("-")) {
		return text.replace(/^-/u, "-0x");
	}

	return `0x${text}`;
};

export const toHex: UnitFormatterWithOptions = (value, { precision } = {}) =>
	Number.parseFloat(toFixed(value, precision)).toString(16).toUpperCase();

export const sci: UnitFormatterWithOptions = (value, { precision } = {}) => value.toExponential(precision ?? undefined);
